import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { ScrollToTop, ExitIntentPopup } from "./components/Shared";
import { LOCATIONS } from "./data/siteData";
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import AboutPage from "./pages/AboutPage";
import PortfolioPage from "./pages/PortfolioPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import ReviewsPage from "./pages/ReviewsPage";
import ContactPage from "./pages/ContactPage";
import FreeEstimatePage from "./pages/FreeEstimatePage";
import LocationPage from "./pages/LocationPage";
import AdminPage from "./pages/AdminPage";
import { PrivacyPage, TermsPage, WarrantyPage } from "./pages/LegalPages";

const Layout = () => (
  <>
    <Header />
    <main className="pt-16 md:pt-20">
      <Outlet />
    </main>
    <Footer />
    <ExitIntentPopup />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Toaster position="top-center" richColors />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/portfolio" element={<PortfolioPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/reviews" element={<ReviewsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy-policy" element={<PrivacyPage />} />
            <Route path="/terms-of-service" element={<TermsPage />} />
            <Route path="/warranty" element={<WarrantyPage />} />
            {LOCATIONS.map((loc) => (
              <Route key={loc.slug} path={`/${loc.slug}`} element={<LocationPage loc={loc} />} />
            ))}
          </Route>
          <Route path="/free-estimate" element={<FreeEstimatePage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
